import {
  Component,
  AfterViewInit,
  EventEmitter,
  Output,
  OnInit
} from '@angular/core';
import {
  NgbModal,
  ModalDismissReasons,
  NgbPanelChangeEvent,
  NgbCarouselConfig
} from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '@app/core';
import { Router } from '@angular/router';
import moment from 'moment';
declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements OnInit, AfterViewInit {
  sucursal: any;
  diasDiferencia: any;

  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};

  public showSearch = false;

  currentUser: any;
  apellidos: string;
  nombres: string;
  email: string;

  username: string;

  currentUserSubscription: Subscription;

  constructor(
    private modalService: NgbModal,
    public router: Router,
    private authService: AuthenticationService
  ) {}

  ngOnInit() {
    // this.currentUserSubscription = this.authService.currentUser.subscribe(
    //    user => {
    //    this.currentUser = user;
    //   this.apellidos = this.currentUser.data.user.apellidos;
    //  this.nombres = this.currentUser.data.user.nombres;
    //  this.email = this.currentUser.data.user.email;
    //  console.log(this.currentUser);
    //  }
    //   );
    this.currentUser = this.authService.credentials.user;
    this.username = this.currentUser.username;
    // console.log(this.currentUser);
    //   this.apellidos = this.currentUser.apellidos;
    //  this.nombres = this.currentUser.nombres;
    // this.email = this.currentUser.email;

    this.sucursal = JSON.parse(
      localStorage.getItem('credentials')
    ).user.sucursal;
    if (this.sucursal) {
      this.calcularDias(this.sucursal.fecha_limite);
    }
  }

  ngAfterViewInit() {}

  eliminarCache() {
    this.authService.logout();

    this.router.navigate(['/login']);
  }

  calcularDias(date: any) {
    const fecha = moment(date);
    const fechaAux = moment().format('YYYY-MM-DD');
    const fechaActual = moment(fechaAux);
    this.diasDiferencia = fecha.diff(fechaActual, 'days');
    // console.log(fecha.diff(fechaActual, 'days'), ' dias de diferencia');
  }
}
